import { isKeyOf } from './objects.mjs';

function extractStyleFromTheme(themeSection, key, defaultValue) {
    if (key && isKeyOf(themeSection, key)) {
        return themeSection[key];
    }
    return defaultValue;
}

export { extractStyleFromTheme };
